import type { TourChapter } from '@greenrinse/features';

// Admin auto-play tour. Text: tour.admin.<id> in the locales. Clicks only open pages, rows, tabs and close dialogs — nothing is saved.
const nav = (to: string) => `.gr-nav-link[href$="/${to}"]`;
const headerPrimary = '.gr-stack > .gr-row > .gr-row > .gr-btn--primary';

export const adminTour: TourChapter[] = [
  { id: 'signin', steps: [
    { id: 'welcome', path: '/login' },
    { id: 'pills', path: '/login', el: '.gr-login__demo' },
    { id: 'signin', path: '/login', el: '[data-demo="admin"]', click: true },
    { id: 'submit', path: '/login', el: 'form button[type="submit"]', click: true },
  ] },
  { id: 'dashboard', steps: [
    { id: 'today', path: '/', el: '[data-tour="kpis"]' },
    { id: 'exceptions', path: '/', el: '[data-tour="kpi-exceptions"]' },
    { id: 'month', path: '/', el: '[data-tour="trend"]' },
    { id: 'coverage', path: '/', el: '[data-tour="coverage"]' },
    { id: 'bell', path: '/', el: '.gr-topbar__actions [aria-label]:not([data-tour])' },
  ] },
  { id: 'field', steps: [
    { id: 'to_tracking', path: '/', el: nav('tracking'), click: true },
    { id: 'map', path: '/tracking', el: '.gr-live-grid > .gr-card:nth-child(1)' },
    { id: 'vans', path: '/tracking', el: '.gr-live-grid > .gr-card:nth-child(2)' },
    { id: 'to_schedule', path: '/tracking', el: nav('schedule'), click: true },
    { id: 'calendar', path: '/schedule', el: '.gr-form-grid > .gr-card' },
    { id: 'add_visit', path: '/schedule', el: '.gr-stack > .gr-row > .gr-row > .gr-btn:last-child' },
    { id: 'plan', path: '/schedule', el: '.gr-stack > .gr-row > .gr-row > .gr-btn:nth-last-child(2)' },
    { id: 'to_teams', path: '/schedule', el: nav('teams'), click: true },
    { id: 'teams', path: '/teams', el: '.gr-table' },
  ] },
  { id: 'records', steps: [
    { id: 'to_records', path: '/teams', el: nav('records'), click: true },
    { id: 'filters', path: '/records', el: '.gr-filters' },
    { id: 'search', path: '/records', el: '.gr-filters input.gr-input', type: 'A 12345' },
    { id: 'open', path: '/records', el: '.gr-table tbody tr', click: true },
    { id: 'detail', el: '.gr-modal' },
    { id: 'close', el: '.gr-modal__head button', click: true },
    { id: 'to_exceptions', path: '/records', el: nav('exceptions'), click: true },
    { id: 'reasons', path: '/exceptions', el: '.gr-grid > .gr-card:nth-child(2)' },
    { id: 'bulk', path: '/exceptions', el: '.gr-table' },
  ] },
  { id: 'billing', steps: [
    { id: 'to_partners', path: '/exceptions', el: nav('partners'), click: true },
    { id: 'partners', path: '/partners', el: '.gr-table' },
    { id: 'to_contracts', path: '/partners', el: nav('contracts'), click: true },
    { id: 'contracts', path: '/contracts', el: '.gr-table' },
    { id: 'to_reconciliation', path: '/contracts', el: nav('reconciliation'), click: true },
    { id: 'periods', path: '/reconciliation', el: '.gr-table' },
    { id: 'new_period', path: '/reconciliation', el: headerPrimary },
    { id: 'to_disputes', path: '/reconciliation', el: nav('disputes'), click: true },
    { id: 'disputes', path: '/disputes', el: '.gr-stack > .gr-card' },
    { id: 'to_invoices', path: '/disputes', el: nav('invoices'), click: true },
    { id: 'generate', path: '/invoices', el: headerPrimary },
    { id: 'export', path: '/invoices', el: '.gr-stack > .gr-row > .gr-row > .gr-btn--outline' },
    { id: 'invoices', path: '/invoices', el: '.gr-stack > .gr-card' },
  ] },
  { id: 'insights', steps: [
    { id: 'to_reports', path: '/invoices', el: nav('reports'), click: true },
    { id: 'tabs', path: '/reports', el: '.gr-tabs' },
    { id: 'revenue', path: '/reports', el: '.gr-tabs > button:nth-child(2)', click: true },
    { id: 'to_sustainability', path: '/reports', el: nav('sustainability'), click: true },
    { id: 'esg', path: '/sustainability', el: '.gr-grid' },
    { id: 'esg_pdf', path: '/sustainability', el: '.gr-row > .gr-row > .gr-btn--outline' },
  ] },
  { id: 'setup', steps: [
    { id: 'to_settings', path: '/sustainability', el: nav('settings'), click: true },
    { id: 'branding', path: '/settings', el: 'form.gr-stack > .gr-card:nth-of-type(1)' },
    { id: 'tab_ai', path: '/settings', el: '[data-tab="ai"]', click: true },
    { id: 'plates', path: '/settings', el: 'form.gr-stack > .gr-card:nth-of-type(1)' },
    { id: 'ai', path: '/settings', el: 'form.gr-stack > .gr-card:nth-of-type(3)' },
    { id: 'replay', path: '/settings', el: '[data-tour="replay"]' },
  ] },
];
